import React, { ReactElement } from "react";
import MySettlementList from "../../components/Finance/Settlements";
import Layout from "../../components/layout";

const MySettlementPage = (): ReactElement => {
  return (
    <Layout>
      <MySettlementList />
    </Layout>
  );
};

export default MySettlementPage;
